import React, { useEffect, useState, useContext } from "react";
import { Form, Row, Col, Button, Spinner } from "react-bootstrap";
import { RenderIf, formatDateYYYY_MM_DD, getCurrentDateTime } from "../../functions/common-functions";
import Swal from "sweetalert2";
import axios from "axios";
import withReactContent from "sweetalert2-react-content";
import { AuthContext } from "../../contexts/AuthContext";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import SingleValuePopUp from "../utils/SingleValuePopUp";
import { BiSelectMultiple } from "react-icons/bi";
import { IoArrowBack } from "react-icons/io5";
import { FaHistory } from "react-icons/fa";
import { AddDisposalIntimation, getAllDisposalIntimationForms, getAllUOM, addWorkflowEntry } from "../../services/disposal-intimation-service";
import { findDivisionalApprover, getUsersForRole } from "../../services/user-service";
import MultiValuePopUp from "../utils/MultiValuePopUp";
import DragDropRender from "../utils/DragDropRender";
import { getPresignedURL } from "../../functions/upload";
import { ALERT_PARAMS } from "../../utils/constant";
import WorkflowHistoryModal from "./WorkflowHistoryModal";
import Validate from "../utils/Validation";
import { getValidUserData } from "../../services/user-service";
import { addLogDetails } from "../../services/logger-entry-service";

const DisposalIntimation = (props) => {
    const MySwal = withReactContent(Swal);
    const context = useContext(AuthContext);
    const userDetails = {
        email: context.userEmail,
        userName: context.userName,
        userId: context.userId,
        division: context.division
    };

    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const todayDate = getCurrentDateTime("/");

    const [disposalObj, setDisposalObj] = useState({
        IntimationDate: formatDateYYYY_MM_DD(new Date()),
        InitiatorUserID: userDetails.userId || "",
        InitiatorName: userDetails.userName || "",
        InitiatorContactNumber: "",
        InitiatorDivision: userDetails.division || "",
        InitiatorLocation: "",
        IfOtherLoc: "",
        LogisticCompany: "",
        AssetNonAssetItem: "",
        ItemCode: "",
        ItemDescription: "",
        ItemDetails: "",
        ItemType: "",
        ProductClass: "",
        CommodityCodes: "",
        Quantity: "",
        UOM: "",
        GSTRate: "",
        Status: "Pending for Divisional Approval",
        CurrentApprover: "",
        AttachImage: "",
        AttachImageFile: null,
        AttachDocument1: "",
        AttachDocument1File: null,
        AttachDocument2: "",
        AttachDocument2File: null,
        AttachDocument3: "",
        AttachDocument3File: null,
        CreatedBy: userDetails.userId,
        CreatedByName: userDetails.userName,
        CreatedOn: todayDate,
        ModifiedBy: userDetails.userId,
        ModifiedByName: userDetails.userName,
        ModifiedOn: todayDate
    });

    const [error, setError] = useState({
        InitiatorContactNumber: { status: false, message: "" },
        InitiatorLocation: { status: false, message: "" },
        IfOtherLoc: { status: false, message: "" },
        LogisticCompany: { status: false, message: "" },
        AssetNonAssetItem: { status: false, message: "" },
        ItemCode: { status: false, message: "" },
        ItemDetails: { status: false, message: "" },
        ItemType: { status: false, message: "" },
        ProductClass: { status: false, message: "" },
        CommodityCodes: { status: false, message: "" },
        Quantity: { status: false, message: "" },
        UOM: { status: false, message: "" },
        GSTRate: { status: false, message: "" }
    });

    const [popUp, setPopUp] = useState({
        name: "",
        type: "",
        key: "",
        value: ""
    });

    const [locationList, setLocationList] = useState([]);
    const [uomList, setUomList] = useState([]);

    useEffect(() => {
        if (userDetails.division) {
            fetchLocationsByDivision(userDetails.division);
        }
        fetchUOM();
    }, [userDetails.division]);

    useEffect(() => {
        if (props.rowData && props.action !== "Add") {
            setDisposalObj({
                ...props.rowData,
                IntimationDate: props.rowData.IntimationDate ? formatDateYYYY_MM_DD(new Date(props.rowData.IntimationDate)) : formatDateYYYY_MM_DD(new Date())
            });
            if (props.rowData.InitiatorDivision) {
                fetchLocationsByDivision(props.rowData.InitiatorDivision);
            }
        }
    }, [props.rowData, props.action]);

    const fetchLocationsByDivision = async (division) => {
        try {
            // const locations = await getActiveLocationForDivision(division);
            const data = await getValidUserData("UserMaster", "UserId", userDetails.userId)
            const locations = data[0].Location.split(",").map(item => item.trim());

            const dropdownLocations = locations.map(item => ({
                LocationCode: locations.indexOf(item),
                LocationName: item
            }));
            setLocationList(dropdownLocations);
        } catch (error) {
            console.error("Error fetching locations:", error);
            setLocationList([]);
        }
    };

    const fetchUOM = async () => {
        try {
            const uoms = await getAllUOM();
            setUomList(uoms.filter(uom => uom.DeleteIndication));
        } catch (error) {
            console.error("Error fetching UOMs:", error);
            setUomList([]);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Validation for contact number
        if (name === "InitiatorContactNumber") {
            const numericRegex = /^[0-9]*$/;
            if (!numericRegex.test(value) || value.length > 10) {
                return;
            }
        }

        // Validation for logistic company
        if (name === "LogisticCompany") {
            const numericRegex = /^[0-9]*$/;
            if (!numericRegex.test(value) || value.length > 4) {
                return;
            }
        }

        // Validation for decimal fields (Quantity and GSTRate)
        if (name === "Quantity" || name === "GSTRate") {
            if (name === "GSTRate" && value.length > 5) {
                return;
            }
            // For Quantity field, allow "As Per Weight" or numeric with 2 decimals
            if (name === "Quantity") {
                const asPerWeight = "As Per Weight";
                if (value === "" || value === asPerWeight) {
                    // Allow empty or exact phrase
                } else if (asPerWeight.startsWith(value)) {
                    // Allow partial typing of "As Per Weight"
                } else if (/^\d*\.?\d{0,2}$/.test(value)) {
                    // Allow numeric with up to 2 decimals
                } else {
                    return;
                }
            } else {
                // For GSTRate, keep existing decimal validation
                if (value === '' || /^\d+(\.\d{0,2})?$/.test(value)) {
                } else {
                    return;
                }
            }
        }

        // Validation for item details
        if (name === "ItemDetails") {
            const allowedChars = /^[a-zA-Z0-9 ]*$/;
            if (!allowedChars.test(value)) {
                return;
            }
        }

        // Validation for IfOtherLoc field
        if (name === "IfOtherLoc") {
            const alphanumericRegex = /^[a-zA-Z0-9 ]*$/;
            if (!alphanumericRegex.test(value) || value.length > 50) {
                return;
            }
        }

        // Handle asset/non-asset item change
        if (name === "AssetNonAssetItem") {
            if (value === "Stock Items") {
                setDisposalObj((prevState) => ({
                    ...prevState,
                    ItemCode: "As per list attached",
                    ItemDescription: "As per list attached",
                    ItemType: "",
                    ProductClass: "",
                    CommodityCodes: ""
                }));
            } else {
                setDisposalObj((prevState) => ({
                    ...prevState,
                    ItemCode: "",
                    ItemDescription: "",
                    ItemType: "",
                    ProductClass: "",
                    CommodityCodes: ""
                }));
            }
        }

        // Handle location change to clear IfOtherLoc
        if (name === "InitiatorLocation") {
            setDisposalObj((prevState) => ({
                ...prevState,
                IfOtherLoc: "" // Clear IfOtherLoc when location changes
            }));
        }

        // Handle division change to fetch locations
        if (name === "InitiatorDivision") {
            setDisposalObj((prevState) => ({
                ...prevState,
                InitiatorLocation: "", // Reset location when division changes
                IfOtherLoc: "" // Clear IfOtherLoc when division changes
            }));
            if (value) {
                fetchLocationsByDivision(value);
            } else {
                setLocationList([]);
            }
        }

        setDisposalObj((prevState) => ({
            ...prevState,
            [name]: value
        }));

        // Clear error when user starts typing
        if (error[name]?.status) {
            setError((prevState) => ({
                ...prevState,
                [name]: { status: false, message: "" }
            }));
        }
    };

    const validateDetails = () => {
        let isError = false;
        const errorMsg = { ...error };

        if (!disposalObj.InitiatorContactNumber.trim() || disposalObj.InitiatorContactNumber.length !== 10) {
            isError = true;
            errorMsg.InitiatorContactNumber = { status: true, message: "Contact number must be exactly 10 digits" };
        }

        if (!disposalObj.InitiatorLocation.trim()) {
            isError = true;
            errorMsg.InitiatorLocation = { status: true, message: "Location is required" };
        }

        if (disposalObj.InitiatorLocation === "Other" && !disposalObj.IfOtherLoc.trim()) {
            isError = true;
            errorMsg.IfOtherLoc = { status: true, message: "If Other Location is required when Location is Other" };
        }

        if (!disposalObj.LogisticCompany.trim() || disposalObj.LogisticCompany.length !== 4) {
            isError = true;
            errorMsg.LogisticCompany = { status: true, message: "Logistic company must be exactly 4 digits" };
        }

        if (!disposalObj.AssetNonAssetItem.trim()) {
            isError = true;
            errorMsg.AssetNonAssetItem = { status: true, message: "Asset/Non-asset item is required" };
        }

        if (!disposalObj.ItemCode.trim()) {
            isError = true;
            errorMsg.ItemCode = { status: true, message: "Item code is required" };
        }

        if (!disposalObj.ItemDetails.trim()) {
            isError = true;
            errorMsg.ItemDetails = { status: true, message: "Item details is required" };
        }

        // if (disposalObj.AssetNonAssetItem === "Asset Item" || disposalObj.AssetNonAssetItem === "Non-Asset Item") {
        //     if (!disposalObj.ItemType) {
        //         isError = true;
        //         errorMsg.ItemType = { status: true, message: "Item Type is blank" };
        //     }
        //     if (!disposalObj.ProductClass) {
        //         isError = true;
        //         errorMsg.ProductClass = { status: true, message: "Product Class is blank" };
        //     }
        //     if (!disposalObj.CommodityCodes) {
        //         isError = true;
        //         errorMsg.CommodityCodes = { status: true, message: "Commodity Code is blank" };
        //     }
        // }

        if (!disposalObj.Quantity || (!/^[a-zA-Z]/.test(disposalObj.Quantity) && parseFloat(disposalObj.Quantity) <= 0)) {
            isError = true;
            errorMsg.Quantity = { status: true, message: "Valid quantity is required" };
        }

        if (!disposalObj.UOM.trim()) {
            isError = true;
            errorMsg.UOM = { status: true, message: "UOM is required" };
        }

        if (!disposalObj.GSTRate || parseFloat(disposalObj.GSTRate) < 0 || parseFloat(disposalObj.GSTRate) > 100) {
            isError = true;
            errorMsg.GSTRate = { status: true, message: "GST rate should be between 0 to 100" };
        }

        setError(errorMsg);
        return isError;
    };

    const uploadFiles = async (signedURL, file) => {
        try {
            if (signedURL && file) {
                await axios.put(signedURL, file, {
                    headers: {
                        'Content-Type': file.type,
                    },
                });
            }
            return "";
        } catch (error) {
            console.error("File upload error:", error);
            return error;
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateDetails()) {
            const isEdit = props.action === "Edit";
            
            // Check for divisional approver before submission
            if (!isEdit) {
                const approvers = await findDivisionalApprover(disposalObj.InitiatorDivision, disposalObj.InitiatorLocation);
                
                if (approvers.length === 0) {
                    MySwal.fire({
                        text: "No Divisional Approver found for your Division and Location. Kindly contact Corporate Finance team for maintaining approval authority.",
                        imageUrl: errorImage,
                        customClass: "swal-success"
                    });
                    return;
                }
            }
            
            MySwal.fire({
                text: `Are you sure, do you want to ${isEdit ? "Update" : "Submit"} Disposal Intimation?`,
                confirmButtonText: isEdit ? "Update" : "Submit",
                title: `${isEdit ? "Update" : "Submit"} Disposal Intimation`,
                ...ALERT_PARAMS,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setLoading(true);

                    try {
                        let result;
                        let intimationNumber;
                        let submissionData = {};
                        const todayDate = getCurrentDateTime("/");

                        if (isEdit) {
                            // Update existing intimation
                            intimationNumber = disposalObj.IntimationNumber;
                            submissionData = {
                                ...disposalObj,
                                Status: "Pending for Divisional Approval",
                                PendingWith: "DIVAPPROVER",
                                ModifiedBy: userDetails.userId,
                                ModifiedByName: userDetails.userName,
                                ModifiedOn: todayDate
                            };
                        } else {
                            // Create new intimation
                            intimationNumber = await generateIntimationNumber();

                            submissionData = {
                                ...disposalObj,
                                IntimationNumber: intimationNumber,
                                PK: "DisposalIntimation",
                                SK: "IntimationNumber#" + intimationNumber,
                                Status: "Pending for Divisional Approval",
                                PendingWith: "DIVAPPROVER"
                            };
                        }

                        // Handle file uploads first
                        const fileFields = ['AttachImage', 'AttachDocument1', 'AttachDocument2', 'AttachDocument3'];
                        const uploadedFiles = {};

                        for (const field of fileFields) {
                            const fileObj = disposalObj[`${field}File`];
                            // Only upload if fileObj is a File object (new upload), not a string (existing file)
                            if (fileObj && fileObj instanceof File) {
                                try {
                                    console.log(`Uploading ${field}:`, fileObj.name);
                                    const filename = fileObj.name;
                                    const signedURL = await getPresignedURL(
                                        `DisposalIntimation/${intimationNumber.replace(/\//g, '_')}/${filename}`
                                    );
                                    console.log(`Got presigned URL for ${field}:`, signedURL);
                                    if (signedURL) {
                                        const uploadResult = await uploadFiles(signedURL, fileObj);
                                        if (!uploadResult) { // uploadResult is empty string on success
                                            uploadedFiles[field] = filename;
                                            console.log(`Successfully uploaded ${field}`);
                                        } else {
                                            console.error(`Failed to upload ${field}:`, uploadResult);
                                            // Don't include failed uploads in DB
                                            submissionData[field] = "";
                                        }
                                    }
                                } catch (fileError) {
                                    console.error(`Error uploading ${field}:`, fileError);
                                    // Don't include failed uploads in DB
                                    submissionData[field] = "";
                                }
                            } else if (typeof disposalObj[field] === 'string' && disposalObj[field]) {
                                // Keep existing file names for edit mode
                                uploadedFiles[field] = disposalObj[field];
                            }
                        }

                        // Update submissionData with only successfully uploaded files
                        Object.keys(uploadedFiles).forEach(field => {
                            submissionData[field] = uploadedFiles[field];
                        });

                        // Get current user names for pending roles
                        let pendingWithNames = "";
                        try {
                            const users = await getUsersForRole("DIVAPPROVER");
                            const activeUsers = users.filter(user => user.DeleteIndication);
                            const initiatorLocation = submissionData.InitiatorLocation === "Other" ? submissionData.IfOtherLoc : submissionData.InitiatorLocation;
                            
                            const filteredUsers = activeUsers.filter(user => {
                                const userLocations = user.Location ? user.Location.split(",").map(loc => loc.trim()) : [];
                                return user.Division === submissionData.InitiatorDivision && 
                                       userLocations.includes(initiatorLocation);
                            });
                            pendingWithNames = filteredUsers.map(user => user.UserName).join(", ");
                        } catch (error) {
                            console.error("Error fetching pending users:", error);
                            pendingWithNames = "DIVAPPROVER";
                        }

                        const workflowData = {
                            Initiator: userDetails.email,
                            Action: isEdit ? "Resubmitted" : "Submitted",
                            ActionBy: userDetails.userId,
                            ActionByName: userDetails.userName,
                            ActionDate: getCurrentDateTime("-"),
                            Remarks: "",
                            Status: "Pending for Divisional Approval",
                            PendingWith: "DIVAPPROVER",
                            PendingWithNames: pendingWithNames
                        };

                        result = await AddDisposalIntimation(submissionData);

                        if (result.status) {
                            await addWorkflowEntry(intimationNumber, workflowData);
                            await addLogDetails(submissionData, isEdit ? "Edit" : "Add", intimationNumber, "DisposalIntimationLog", userDetails, "Transaction");

                            setLoading(false);
                            MySwal.fire({
                                text: props.action === "Edit"
                                    ? `Disposal intimation updated successfully. Intimation Number: ${intimationNumber}`
                                    : `Disposal intimation submitted successfully. Intimation Number: ${intimationNumber}`,
                                imageUrl: successImage,
                                customClass: "swal-success"
                            });

                            props.onHide();
                            props.setReload(!props.reload);

                        } else {
                            setLoading(false);
                            MySwal.fire({
                                text: result.message,
                                imageUrl: errorImage,
                                customClass: "swal-success"
                            });
                        }
                    } catch (error) {
                        setLoading(false);
                        MySwal.fire({
                            text: "Unable to process request",
                            imageUrl: errorImage,
                            customClass: "swal-success"
                        });
                    }
                }
            });
        }
    };

    const generateIntimationNumber = async () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;

        // Determine financial year (April to March)
        let financialYear;
        if (currentMonth >= 4) {
            // April to December: current year to next year
            financialYear = `${currentYear}-${String(currentYear + 1).slice(-2)}`;
        } else {
            // January to March: previous year to current year
            financialYear = `${currentYear - 1}-${String(currentYear).slice(-2)}`;
        }

        // Get all disposal intimations for current financial year
        const allIntimations = await getAllDisposalIntimationForms();
        console.log("const allIntimations = await getAllDisposalIntimationForms();", allIntimations);

        const currentFYIntimations = allIntimations.filter(intimation =>
            intimation.IntimationNumber && intimation.IntimationNumber.includes(`DISPOSAL/${financialYear}/`)
        );
        console.log("const currentFYIntimations = allIntimations", currentFYIntimations);

        const serialNumber = currentFYIntimations.length + 1;
        return `DISPOSAL/${financialYear}/${serialNumber}`;
    };

    const handleReset = () => {
        if (props.action === "Edit") {
            setDisposalObj(props.rowData);
        } else {
            setDisposalObj({
                IntimationDate: formatDateYYYY_MM_DD(new Date()),
                InitiatorUserID: userDetails.userId || "",
                InitiatorName: userDetails.userName || "",
                InitiatorContactNumber: "",
                InitiatorDivision: userDetails.division || "",
                InitiatorLocation: "",
                IfOtherLoc: "",
                LogisticCompany: "",
                AssetNonAssetItem: "",
                ItemCode: "",
                ItemDescription: "",
                ItemDetails: "",
                ItemType: "",
                ProductClass: "",
                CommodityCodes: "",
                Quantity: "",
                UOM: "",
                GSTRate: "",
                Status: "Pending for Divisional Approval",
                CurrentApprover: "",
                AttachImage: "",
                AttachImageFile: null,
                AttachDocument1: "",
                AttachDocument1File: null,
                AttachDocument2: "",
                AttachDocument2File: null,
                AttachDocument3: "",
                AttachDocument3File: null,
                CreatedBy: userDetails.userId,
                CreatedByName: userDetails.userName,
                CreatedOn: todayDate,
                ModifiedBy: userDetails.userId,
                ModifiedByName: userDetails.userName,
                ModifiedOn: todayDate
            });
        }

        setError({
            InitiatorContactNumber: { status: false, message: "" },
            InitiatorLocation: { status: false, message: "" },
            IfOtherLoc: { status: false, message: "" },
            LogisticCompany: { status: false, message: "" },
            AssetNonAssetItem: { status: false, message: "" },
            ItemCode: { status: false, message: "" },
            ItemDetails: { status: false, message: "" },
            ItemType: { status: false, message: "" },
            ProductClass: { status: false, message: "" },
            CommodityCodes: { status: false, message: "" },
            Quantity: { status: false, message: "" },
            UOM: { status: false, message: "" },
            GSTRate: { status: false, message: "" }
        });
    };

    const handleDeleteDocument = (fieldName) => {
        setDisposalObj((prevState) => ({
            ...prevState,
            [fieldName]: "",
            [`${fieldName}File`]: null,
        }));
    };

    const handleChangeStatus = async (files, fieldName) => {
        const newFile = files[0];
        if (!newFile) return;

        // Determine format type and file size based on field
        const formats = fieldName === "AttachImage" ? "imgFormats" : "allFormats";
        const maxFileSize = 20 * 1024 * 1024; // 20MB in bytes

        const validationError = Validate(newFile, formats, maxFileSize);
        if (validationError) {
            MySwal.fire({
                text: validationError,
                imageUrl: errorImage,
                customClass: "swal-success",
            });
            return;
        }

        setDisposalObj((prevState) => ({
            ...prevState,
            [fieldName]: newFile.name,
            [`${fieldName}File`]: newFile,
        }));
    };

    const handleFileDownload = async (fileName) => {
        try {
            const intimationNumber = disposalObj.IntimationNumber || props.rowData?.IntimationNumber;
            const filePath = `DisposalIntimation/${intimationNumber.replace(/\//g, '_')}/${fileName}`;
            const downloadURL = await getPresignedURL(filePath);

            if (downloadURL) {
                window.open(downloadURL, '_blank');
            } else {
                MySwal.fire({
                    text: "Unable to download file",
                    imageUrl: errorImage,
                    customClass: "swal-success"
                });
            }
        } catch (error) {
            console.error("Error downloading file:", error);
            MySwal.fire({
                text: "Error downloading file",
                imageUrl: errorImage,
                customClass: "swal-success"
            });
        }
    };

    const setPopUpData = (data) => {
        if (data.name === "Item Master") {
            if (disposalObj.AssetNonAssetItem === "Insurance Claim Items for salvage value") {
                const itemCodes = data.result.map(item => item.ItemCode).join(", ");
                const itemDescriptions = data.result.map(item => item.ItemDescription).join(", ");

                setDisposalObj((prevState) => ({
                    ...prevState,
                    ItemCode: itemCodes,
                    ItemDescription: itemDescriptions,
                    ItemType: "",
                    ProductClass: "",
                    CommodityCodes: ""
                }));
            } else {
                // Handle single selection
                setDisposalObj((prevState) => ({
                    ...prevState,
                    ItemCode: data.result.ItemCode,
                    ItemDescription: data.result.ItemDescription,
                    ItemType: data.result.ItemType || "",
                    ProductClass: data.result.ProductClass || "",
                    CommodityCodes: data.result.CommodityCodes || ""
                }));
            }
        }
    };

    const showPopUp = (name, type, key, value) => {
        setPopUp({ name, type, key, value });
        setShowForm(true);
    };

    return (
        <>
            {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
            <div className="back-navigation" onClick={props.onHide}>
                <IoArrowBack size={24} color="#810055" />
                <span>Back to Disposal Intimation Dashboard</span>
            </div>
            {props.rowData?.Status === "Rework" && (
                <div className="history-btn">
                    <Button
                        variant="outline-primary"
                        className="semiBoldToggleButton cancelBtn"
                        onClick={() => setShowHistory(true)}
                        style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                        <FaHistory size={16} />
                        History
                    </Button>
                </div>
            )}
            {/* </div> */}
            <div className="disposal-form">
                <Form
                    id="disposalintimation"
                    name="disposalintimation"
                    autoComplete="off"
                >
                    <div>
                        <Row>
                            <Row>
                                <Col lg={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="IntimationDate"
                                            type="date"
                                            name="IntimationDate"
                                            placeholder=" "
                                            value={disposalObj.IntimationDate}
                                            readOnly
                                        />
                                        <Form.Label htmlFor="IntimationDate">Date</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col lg={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="InitiatorUserID"
                                            type="text"
                                            name="InitiatorUserID"
                                            placeholder=" "
                                            value={disposalObj.InitiatorUserID}
                                            readOnly
                                        />
                                        <Form.Label htmlFor="InitiatorUserID">Initiator User ID</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col lg={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="InitiatorName"
                                            type="text"
                                            name="InitiatorName"
                                            placeholder=" "
                                            value={disposalObj.InitiatorName}
                                            readOnly
                                        />
                                        <Form.Label htmlFor="InitiatorName">Initiator Name</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="InitiatorContactNumber"
                                            type="text"
                                            name="InitiatorContactNumber"
                                            maxLength="10"
                                            pattern="[0-9]{10}"
                                            placeholder=" "
                                            value={disposalObj.InitiatorContactNumber}
                                            onChange={handleChange}
                                            readOnly={props.action === "View"}
                                            required
                                        />
                                        <Form.Label htmlFor="InitiatorContactNumber">Initiator Contact Number <span className="req-input">*</span></Form.Label>
                                        {error.InitiatorContactNumber.status && (
                                            <Form.Text className="text-danger">
                                                {error.InitiatorContactNumber.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col lg={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="InitiatorDivision"
                                            type="text"
                                            name="InitiatorDivision"
                                            placeholder=" "
                                            value={disposalObj.InitiatorDivision}
                                            readOnly
                                        />
                                        <Form.Label htmlFor="InitiatorDivision">Division</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col lg={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="LogisticCompany"
                                            type="text"
                                            name="LogisticCompany"
                                            maxLength="4"
                                            pattern="[0-9]{4}"
                                            placeholder=" "
                                            value={disposalObj.LogisticCompany}
                                            onChange={handleChange}
                                            readOnly={props.action === "View"}
                                            required
                                        />
                                        <Form.Label htmlFor="LogisticCompany">Logistic Company <span className="req-input">*</span></Form.Label>
                                        {error.LogisticCompany.status && (
                                            <Form.Text className="text-danger">
                                                {error.LogisticCompany.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={disposalObj.InitiatorLocation === "Other" ? 4 : 8} xs={12}>
                                    <Form.Group className="g-select">
                                        <Form.Select
                                            id="InitiatorLocation"
                                            name="InitiatorLocation"
                                            value={disposalObj.InitiatorLocation}
                                            onChange={handleChange}
                                            disabled={props.action === "View"}
                                            required
                                        >
                                            <option value="">Select</option>
                                            {locationList?.map((location) => (
                                                <option key={location.LocationCode} value={location.LocationName}>
                                                    {location.LocationName}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Label className="frm-label" htmlFor="InitiatorLocation">Location <span className="req-input">*</span></Form.Label>
                                        {error.InitiatorLocation.status && (
                                            <Form.Text className="text-danger">
                                                {error.InitiatorLocation.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                {disposalObj.InitiatorLocation === "Other" && (
                                    <Col lg={4} xs={12}>
                                        <Form.Group className="g-input">
                                            <Form.Control
                                                id="IfOtherLoc"
                                                type="text"
                                                name="IfOtherLoc"
                                                maxLength="50"
                                                placeholder=" "
                                                value={disposalObj.IfOtherLoc}
                                                onChange={handleChange}
                                                required
                                            />
                                            <Form.Label htmlFor="IfOtherLoc">If Other <span className="req-input">*</span></Form.Label>
                                            {error.IfOtherLoc.status && (
                                                <Form.Text className="text-danger">
                                                    {error.IfOtherLoc.message}
                                                </Form.Text>
                                            )}
                                        </Form.Group>
                                    </Col>
                                )}
                                <Col md={4} xs={12}>
                                    <Form.Group className="g-select">
                                        <Form.Select
                                            id="AssetNonAssetItem"
                                            name="AssetNonAssetItem"
                                            value={disposalObj.AssetNonAssetItem}
                                            onChange={handleChange}
                                            disabled={props.action === "View"}
                                            required
                                        >
                                            <option value="">Select</option>
                                            <option value="Asset Item">Asset Item</option>
                                            <option value="Non-Asset Item">Non-Asset Item</option>
                                            <option value="Stock Items">Stock Items</option>
                                            <option value="Insurance Claim Items for salvage value">Insurance Claim Items for salvage value</option>
                                        </Form.Select>
                                        <Form.Label className="frm-label" htmlFor="AssetNonAssetItem">Asset/Non-asset Item <span className="req-input">*</span></Form.Label>
                                        {error.AssetNonAssetItem.status && (
                                            <Form.Text className="text-danger">
                                                {error.AssetNonAssetItem.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <div className="d-flex align-items-center">
                                            <Form.Control
                                                id="ItemCode"
                                                type="text"
                                                name="ItemCode"
                                                placeholder=" "
                                                value={disposalObj.ItemCode}
                                                required
                                                readOnly
                                            />
                                            <Form.Label htmlFor="ItemCode">Item Code <span className="req-input">*</span></Form.Label>
                                            <BiSelectMultiple
                                                className={(disposalObj.AssetNonAssetItem === "Stock Items") ? "d-none" : ""}
                                                size={20}
                                                onClick={!disposalObj.AssetNonAssetItem ? undefined : () => showPopUp("Item Master", disposalObj.AssetNonAssetItem === "Insurance Claim Items for salvage value" ? "Multiple" : "Single", "ItemCode", disposalObj.ItemCode)}
                                                color={!disposalObj.AssetNonAssetItem ? "#cccccc" : "#707070"}
                                                style={{ marginLeft: "-2rem", cursor: !disposalObj.AssetNonAssetItem ? "not-allowed" : "pointer" }}
                                                backdrop="static"
                                            />
                                        </div>
                                        {error.ItemCode.status && (
                                            <Form.Text className="text-danger">
                                                {error.ItemCode.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="ItemDescription"
                                            type="text"
                                            name="ItemDescription"
                                            placeholder=" "
                                            value={disposalObj.ItemDescription}
                                            readOnly
                                        />
                                        <Form.Label htmlFor="ItemDescription">Item Description</Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col md={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="ItemType"
                                            type="text"
                                            name="ItemType"
                                            placeholder=" "
                                            value={disposalObj.ItemType}
                                            readOnly
                                        />
                                        <Form.Label htmlFor="ItemType">Item Type</Form.Label>
                                        {error.ItemType.status && (
                                            <Form.Text className="text-danger">
                                                {error.ItemType.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            id="ItemDetails"
                                            name="ItemDetails"
                                            maxLength="250"
                                            placeholder=" "
                                            value={disposalObj.ItemDetails}
                                            onChange={handleChange}
                                            readOnly={props.action === "View"}
                                            required
                                        />
                                        <Form.Label htmlFor="ItemDetails">Item Details <span className="req-input">*</span></Form.Label>
                                        {error.ItemDetails.status && (
                                            <Form.Text className="text-danger">
                                                {error.ItemDetails.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="ProductClass"
                                            type="text"
                                            name="ProductClass"
                                            placeholder=" "
                                            value={disposalObj.ProductClass}
                                            readOnly
                                        />
                                        <Form.Label htmlFor="ProductClass">Product Class</Form.Label>
                                        {error.ProductClass.status && (
                                            <Form.Text className="text-danger">
                                                {error.ProductClass.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="CommodityCodes"
                                            type="text"
                                            name="CommodityCodes"
                                            placeholder=" "
                                            value={disposalObj.CommodityCodes}
                                            readOnly
                                        />
                                        <Form.Label htmlFor="CommodityCodes">Commodity Code</Form.Label>
                                        {error.CommodityCodes.status && (
                                            <Form.Text className="text-danger">
                                                {error.CommodityCodes.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={4} xs={12}></Col>
                            </Row>
                            <Row>
                                <Col md={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <Form.Control
                                            id="Quantity"
                                            type="text"
                                            name="Quantity"
                                            placeholder=" "
                                            value={disposalObj.Quantity}
                                            onChange={handleChange}
                                            readOnly={props.action === "View"}
                                            required
                                        />
                                        <Form.Label htmlFor="Quantity">Quantity <span className="req-input">*</span></Form.Label>
                                        {error.Quantity.status && (
                                            <Form.Text className="text-danger">
                                                {error.Quantity.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={4} xs={12}>
                                    <Form.Group className="g-select">
                                        <Form.Select
                                            id="UOM"
                                            name="UOM"
                                            value={disposalObj.UOM}
                                            onChange={handleChange}
                                            disabled={props.action === "View"}
                                            required
                                        >
                                            <option value="">Select</option>
                                            {uomList?.map((uom) => (
                                                <option key={uom.SK} value={uom.UOMCode}>
                                                    {uom.UOMCode}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        <Form.Label className="frm-label" htmlFor="UOM">UOM <span className="req-input">*</span></Form.Label>
                                        {error.UOM.status && (
                                            <Form.Text className="text-danger">
                                                {error.UOM.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={4} xs={12}>
                                    <Form.Group className="g-input">
                                        <div className="d-flex align-items-center">
                                            <Form.Control
                                                id="GSTRate"
                                                type="number"
                                                name="GSTRate"
                                                step="0.01"
                                                placeholder=" "
                                                value={disposalObj.GSTRate}
                                                onChange={handleChange}
                                                readOnly={props.action === "View"}
                                                required
                                            />
                                            <Form.Label htmlFor="GSTRate">GST Rate <span className="req-input">*</span></Form.Label>
                                            <span style={{ marginLeft: "-3rem", fontSize: "21px", fontWeight: "600", color: "#707070" }}>%</span>
                                        </div>
                                        {error.GSTRate.status && (
                                            <Form.Text className="text-danger">
                                                {error.GSTRate.message}
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6} className="pb-3">
                                    <Form.Label className="SubHeaderProjectDetails"> Attach Image </Form.Label>
                                    <DragDropRender
                                        supportedFilesLabel="Supports: Image formats (JPEG, JPG, PNG), Max File Size – up to 20MB per file"
                                        val={disposalObj.AttachImage}
                                        handleChangeEvent={(params) => handleChangeStatus(params, 'AttachImage')}
                                        handleDeleteDocEvent={() => handleDeleteDocument('AttachImage')}
                                        handleDownloadDocEvent={(fileName) => handleFileDownload(fileName)}
                                        action={props.action}
                                    />
                                </Col>
                                {error.AttachImage && (
                                    <Form.Text className="text-danger">
                                        {error.AttachImage.message}
                                    </Form.Text>
                                )}
                                <Col xs={6} className="pb-3">
                                    <Form.Label className="SubHeaderProjectDetails"> Attach Document 1 </Form.Label>
                                    <DragDropRender
                                        supportedFilesLabel="Supports: PDF, DOC/DOCX, XLS/XLSX, JPEG, JPG, MSG, PNG, ZIP, Email Attachments formats, Max File Size – up to 20MB per file"
                                        val={disposalObj.AttachDocument1}
                                        handleChangeEvent={(params) => handleChangeStatus(params, 'AttachDocument1')}
                                        handleDeleteDocEvent={() => handleDeleteDocument('AttachDocument1')}
                                        handleDownloadDocEvent={(fileName) => handleFileDownload(fileName)}
                                        action={props.action}
                                    />
                                </Col>
                                {error.AttachDocument1 && (
                                    <Form.Text className="text-danger">
                                        {error.AttachDocument1.message}
                                    </Form.Text>
                                )}
                            </Row>
                            <Row>
                                <Col xs={6} className="pb-3">
                                    <Form.Label className="SubHeaderProjectDetails"> Attach Document 2 </Form.Label>
                                    <DragDropRender
                                        supportedFilesLabel="Supports: PDF, DOC/DOCX, XLS/XLSX, JPEG, JPG, MSG, PNG, ZIP, Email Attachments formats, Max File Size – up to 20MB per file"
                                        val={disposalObj.AttachDocument2}
                                        handleChangeEvent={(params) => handleChangeStatus(params, 'AttachDocument2')}
                                        handleDeleteDocEvent={() => handleDeleteDocument('AttachDocument2')}
                                        handleDownloadDocEvent={(fileName) => handleFileDownload(fileName)}
                                        action={props.action}
                                    />
                                </Col>
                                {error.AttachDocument2 && (
                                    <Form.Text className="text-danger">
                                        {error.AttachDocument2.message}
                                    </Form.Text>
                                )}
                                <Col xs={6} className="pb-3">
                                    <Form.Label className="SubHeaderProjectDetails"> Attach Document 3 </Form.Label>
                                    <DragDropRender
                                        supportedFilesLabel="Supports: PDF, DOC/DOCX, XLS/XLSX, JPEG, JPG, MSG, PNG, ZIP, Email Attachments formats, Max File Size – up to 20MB per file"
                                        val={disposalObj.AttachDocument3}
                                        handleChangeEvent={(params) => handleChangeStatus(params, 'AttachDocument3')}
                                        handleDeleteDocEvent={() => handleDeleteDocument('AttachDocument3')}
                                        handleDownloadDocEvent={(fileName) => handleFileDownload(fileName)}
                                        action={props.action}
                                    />
                                </Col>
                                {error.AttachDocument3 && (
                                    <Form.Text className="text-danger">
                                        {error.AttachDocument3.message}
                                    </Form.Text>
                                )}
                            </Row>
                        </Row>
                    </div>
                    {props.action !== "View" && (
                        <Row className="disposal-footer">
                            <Col xs={6} md={6}>
                                <Button className="semiBoldToggleButton cancelBtn" variant="outline-success" onClick={handleReset}>Reset</Button>
                            </Col>
                            <Col xs={6} md={6}>
                                <Button
                                    variant="success"
                                    className="btn-add-color semiBoldToggleButton rightAlignedButton"
                                    onClick={handleSubmit}
                                >
                                    {props.action === "Edit" ? "Update" : "Submit"}
                                </Button>
                            </Col>
                        </Row>
                    )}
                </Form>
            </div>
            <RenderIf isTrue={popUp.type === "Single" && showForm}>
                <SingleValuePopUp
                    show={showForm}
                    onHide={() => setShowForm(false)}
                    setSelected={setPopUpData}
                    mastername={popUp.name}
                    paramkey={popUp.key}
                    paramvalue={popUp.value}
                    backdrop="static"
                />
            </RenderIf>
            <RenderIf isTrue={popUp.type === "Multiple" && showForm}>
                <MultiValuePopUp
                    show={showForm}
                    onHide={() => setShowForm(false)}
                    setSelected={setPopUpData}
                    masterName={popUp.name}
                    selectedItems={popUp.value}
                />
            </RenderIf>

            <WorkflowHistoryModal
                show={showHistory}
                onHide={() => setShowHistory(false)}
                intimationNumber={props.rowData?.IntimationNumber}
            />
        </>
    );
}

export default DisposalIntimation;